
import React from "react";
const InvestmentsIcon = (props) => {
  return (
    <img src="/images/nuevo_ico_consumo.png" alt=""/>
  );
}
export default InvestmentsIcon;
